import axiosInstance from "../axiosConfig";
import {
  AutoRenewalResponse,
  CancelSubscriptionResponse,
  PurchaseMode,
  SubscriptionCheckResponse,
  SubscriptionResponse,
  Tariff,
  TariffFunctionMatrix,
} from "./subscriptionService.types";
import { logger } from "utils/logger";

export const fetchActiveSubscription = async (
  tariffId: number,
): Promise<SubscriptionResponse> => {
  try {
    const response = await axiosInstance.get<SubscriptionResponse>(
      "/subscriptions/active-subscription/",
      { params: { tariff_id: tariffId } },
    );
    return response.data;
  } catch (error) {
    logger.error(`Ошибка получения активной подписки тарифа ${tariffId}:`, error);
    throw error;
  }
};

export const cancelSubscription = async (
  tariffId: number,
): Promise<CancelSubscriptionResponse> => {
  try {
    const response = await axiosInstance.post<CancelSubscriptionResponse>(
      "/subscriptions/cancel-subscription/",
      { tariff_id: tariffId },
    );
    return response.data;
  } catch (error) {
    logger.error(`Ошибка отмены подписки тарифа ${tariffId}:`, error);
    throw error;
  }
};

export const setAutoRenewal = async (
  tariffId: number,
  autoRenewal: boolean,
): Promise<AutoRenewalResponse> => {
  try {
    const response = await axiosInstance.post<AutoRenewalResponse>(
      "/subscriptions/toggle-auto-renewal/",
      { tariff_id: tariffId, auto_renewal: autoRenewal },
    );
    return response.data;
  } catch (error) {
    logger.error(`Ошибка изменения автопродления тарифа ${tariffId}:`, error);
    throw error;
  }
};

export const fetchTariffs = async (): Promise<Tariff[]> => {
  try {
    const response = await axiosInstance.get<Tariff[]>("/subscriptions/tariffs/");
    return response.data;
  } catch (error) {
    logger.error("Ошибка при получении списка тарифов:", error);
    throw error;
  }
};

export const createPayment = async (
  tariffId: number,
  purchaseMode: PurchaseMode = "change",
): Promise<string> => {
  try {
    const response = await axiosInstance.post<{ payment_url: string }>(
      "/subscriptions/create-payment/",
      { tariff_id: tariffId, purchase_mode: purchaseMode },
    );
    return response.data.payment_url;
  } catch (error) {
    logger.error("Ошибка при создании платежа:", error);
    throw error;
  }
};

export const fetchTariffFunctionMatrix = async (): Promise<TariffFunctionMatrix> => {
  try {
    const response = await axiosInstance.get<TariffFunctionMatrix>(
      "/subscriptions/tariff-function-matrix/",
    );
    return response.data;
  } catch (error) {
    logger.error("Ошибка при получении матрицы функций и тарифов:", error);
    throw error;
  }
};

export const checkActiveSubscription = async (tariffId?: number): Promise<boolean> => {
  try {
    const response = await axiosInstance.get<SubscriptionCheckResponse>(
      "/subscriptions/check-subscription/",
      { params: tariffId ? { tariff_id: tariffId } : undefined },
    );
    return response.data.has_active_subscription;
  } catch (error) {
    logger.error("Ошибка при проверке активной подписки:", error);
    return false;
  }
};
